import { render } from "./UpdateTime.vue?vue&type=template&id=6d4857d5&scoped=true"
import script from "./UpdateTime.vue?vue&type=script&lang=ts"
export * from "./UpdateTime.vue?vue&type=script&lang=ts"

import "./UpdateTime.vue?vue&type=style&index=0&id=6d4857d5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d4857d5"

export default script